import { getPageSource, track } from '@mc/track-event'

const EVENT_NAME = 'Plans Page Row Viewed'

export const trackLearningToolsRowViewed = () =>
  track(EVENT_NAME, {
    category: 'pricing matrix',
    row: 'learning tools',
    row_name: 'learning tools',
    row_position_index: 3,
    page_source: getPageSource(),
  })

export const trackCertificatesRowViewed = () =>
  track(EVENT_NAME, {
    category: 'pricing matrix',
    row: 'certificates',
    row_name: 'certificates',
    row_position_index: 4,
    page_source: getPageSource(),
  })
